import React, { useEffect, useLayoutEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useAppContext } from "@context/AppContext";
import { useApiClient } from "@hooks/useApiClient";

const Faqs = () => {
  const { themeConfig } = useAppContext();
  const { get } = useApiClient();
  const [build, setBuild] = useState({});
  const [md, setMD] = useState(undefined);
  const [isLoading, setLoading] = useState(true);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  useEffect(() => {
    setMD(themeConfig.APP_ABOUT_FAQS);
    const getBuildInfo = async () => {
      let response = await get(`/build`);
      setBuild(response);
    };
    getBuildInfo();
  }, [themeConfig, get]);

  useEffect(() => {
    if (md !== undefined) {
      setLoading(false);
    }
  }, [md]);

  const renderFaqContent = () => {
    return (
      <>
        <ReactMarkdown>
          {"## What versions of the software are running?"}
        </ReactMarkdown>
        <p>
          The website version is {`v${build.version}#${build.number}`}. The
          smart contract version is v{build.contractVersion}.
        </p>
      </>
    );
  };

  return (
    <section id="faqs" className="page-settings">
      <h1 className="faqs__title title-styles-nocaptial">
        Questions and Answers about {themeConfig.APP_SPONSOR}
      </h1>
      <div className="faqs__qas-box">
        <div className="faqs__md">
          <ReactMarkdown>{md}</ReactMarkdown>
          {!isLoading && renderFaqContent()}
        </div>
      </div>
    </section>
  );
};

export default Faqs;
